import type {
  Product,
  SelectedProduct,
} from "../../../../constants/modelCompareData/types";

export const filterProducts = (
  product: Product,
  selectedProducts: SelectedProduct[],
): boolean =>
  selectedProducts.some(
    (selectedProduct) => selectedProduct.productId === product.id,
  );
